export default __webpack_public_path__ + "static/media/slider03.275b0dc1.webp";